import { GET_AUCTION } from '../constants/auction';

const INITIAL_STATE = {
  header_kpi: {},
  feed: [],
  auction: {
    volumes_and_values: [],
    kpis: {
      wine_name: '',
      local_currency: 'EUR',
      displayed_currency: 'EUR',
      date: null,
      min_price: 0,
      min_local_price: 0,
      min_vintage: '',
      min_store: '',
      min_market: '',
      min_date: null,
      avg_price: 0,
      total_bottles: 0,
      total_sales: 0
    },
    avg_prices: [],
    filters: {
      client_wines: [],
      stores: [],
      markets: []
    }
  }
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_AUCTION:
      return {
        ...state,
        header_kpi: payload.header_kpi,
        feed: payload.feed,
        kpis: payload.kpis,
        filters: payload.filters,
        avg_prices: payload.avg_prices,
        volumes_and_values: payload.volumes_and_values
      };
    default:
      return state;
  }
};
